<submission-search-bar [advancedEnabled]="advancedEnabled"
                       (advancedEnabledChange)="setMode($event)"
                       [(basicSearchStr)]="basicSearchStr"
                       [advancedSearchParameters]="advancedSearchParameters"
                       (search)="runSearch()"
                       (clear)="clear()"/>
@if (hasSearched() && financeResults()?.taList?.length) {
  <div class="flex items-center gap-3 pt-3">
    <div class="px-2 text-sm font-semibold font-['Roboto_Condensed'] text-slate-500">
      Search Results
    </div>
    <div class="flex-1"></div>
    <p-button outlined severity="secondary" size="small" icon="fa-regular fa-file-export" label="Export" (onClick)="exportResults()"></p-button>
    <div class="text-xs text-slate-500">
      Showing {{financeResults()!.currentCount}} of {{financeResults()!.totalCount}} results
    </div>
  </div>
  <div #scrollContainer scrollHeight [bottomPadding]="80" class="mt-2 rounded-lg border-[1px] border-surface-300 overflow-y-auto">
    <p-table [value]="financeResults()!.taList!"
             stripedRows
             [tableStyle]="{'min-width': '40rem'}"
             sortField="taNumber"
             [sortOrder]="-1"
             class="ta-list rounded-lg">
      <ng-template #header>
        <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed']">
          <th class="rounded-tl-lg ta-col-prepaid"></th>
          <th class="ta-col-attachment"></th>
          <th>TA Number</th>
          <th>Status</th>
          <th>Primary Traveller</th>
          <th>No. of Travellers</th>
          <th>Project Code</th>
          <th>Start</th>
          <th>End</th>
          <th class="ta-col-actions">Actions</th>
          <th class="rounded-tr-lg ta-col-comments"></th>
        </tr>
      </ng-template>
      <ng-template #body let-taSubmission let-rowIndex="rowIndex">
        <tr class="text-xs font-normal font-['Roboto_Condensed'] hover:cursor-pointer" (click)="setSelectedTa(taSubmission)" (dblclick)="viewTaSubmission(taSubmission)">
          <td class="ta-col-prepaid" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-bl-lg': (rowIndex === (financeResults()!.taList!.length) - 1)}">
            <prepaid-indicator [taDetails]="taSubmission"></prepaid-indicator>
          </td>
          <td class="ta-col-attachment" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <attachment-indicator [taDetails]="taSubmission"></attachment-indicator>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <button class="text-primary-500 hover:underline font-semibold cursor-pointer"
                    (click)="viewTaSubmission(taSubmission); $event.stopPropagation()">
              {{taSubmission.taNumber}}
            </button>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <p-chip>
              <div class="whitespace-nowrap">{{toTAStatusText(taSubmission.status)}}</div>
            </p-chip>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <div class="flex gap-1 items-center">
              @if (taSubmission.travellerCount > 1) {
                <i class="fa-solid fa-users"></i>
              } @else {
                <i class="fa-solid fa-user"></i>
              }
              <span class="text-nowrap">{{taSubmission.primaryTraveller?.details?.name}}</span>
            </div>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.travellerCount}}</td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.projectCode}}</td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.startDate | date:'dd/MM/yy'}}</td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.endDate | date:'dd/MM/yy'}}</td>
          <td class="ta-col-actions" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <div class="flex items-center">
              <p-button [style]="{height:'1.8em'}" [text]="true" severity="primary" size="small" (onClick)="setSelectedTa(taSubmission); $event.stopPropagation()"><span class="text-nowrap">View Summary</span></p-button>
            </div>
          </td>
          <td class="ta-col-comments" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-br-lg': (rowIndex === (financeResults()!.taList!.length) - 1)}">
            <ta-comment-count [count]="taSubmission.commentCount"></ta-comment-count>
          </td>
        </tr>
      </ng-template>
    </p-table>


    @if (canLoadMore()) {
      <div #loadMoreSentinel class="flex items-center justify-center gap-3 py-3">
        <p-button label="Load More"
                  severity="secondary"
                  size="small"
                  icon="fa fa-arrow-down"
                  [disabled]="isLoading()"
                  (onClick)="loadMore()">
        </p-button>
      </div>
    }
  </div>

} @else if (hasSearched() && !financeResults()?.taList?.length) {
  <div class="px-2 pt-4 text-slate-500 text-sm font-normal font-['Inter'] leading-6"><i>Your search returned no results</i></div>
} @else {
  <div class="px-2 pt-4 text-slate-500 text-sm font-normal font-['Inter'] leading-6">{{searchGuidance()}}</div>
}
